import script from "./ShopCartServicePackageDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartServicePackageDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartServicePackageDetails.vue?vue&type=style&index=0&id=15aecc3d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15aecc3d"]])

export default __exports__